import { useState } from 'react';

import { Button } from '../../shared/ui/button';
import { DangerZone } from '../../shared/ui/danger-zone';
import { PlusIcon } from '../../shared/ui/icons';
import {
  ApiKeysPanel,
  NewKeyDialog,
  RevokeAllKeys,
  useApiKeys,
  type IMintedKey,
} from '../../features/api-keys';
import { useOrganizationSettings } from './use-organization-settings';
import { SettingsShell } from './settings-shell';

export const ApiKeysPage = () => {
  const { timeZone } = useOrganizationSettings();
  const keys = useApiKeys();
  const [creating, setCreating] = useState(false);
  const [minted, setMinted] = useState<IMintedKey | null>(null);

  return (
    <SettingsShell
      active="/settings/keys"
      question="The keys scripts and other services use to call this organization’s API."
      actions={
        <Button size="sm" onClick={() => setCreating(true)}>
          <PlusIcon size={12} /> New key
        </Button>
      }
    >
      <ApiKeysPanel
        keys={keys}
        minted={minted}
        onMintedClose={() => setMinted(null)}
        onCreate={() => setCreating(true)}
        timeZone={timeZone}
      />
      <DangerZone>
        <RevokeAllKeys keys={keys} />
      </DangerZone>
      <NewKeyDialog open={creating} onOpenChange={setCreating} keys={keys} onMinted={setMinted} />
    </SettingsShell>
  );
};
